module.exports = __webpack_public_path__ + "img/learn.bfc2b270.webp";